import SearchRequestBookingMagnet from './SearchRequestBookingMagnet';

export default SearchRequestBookingMagnet;
